import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ListFiltersComponent } from 'elbuild-ui-componentslib';
import { ParamsService } from 'elbuild-ui-lib-core';

@Component({
	selector: 'app-activity-list-filters',
	templateUrl: './activity-list-filters.component.html',
	styleUrls: ['./activity-list-filters.component.scss']
})
export class ActivityListFiltersComponent extends ListFiltersComponent implements OnInit {

	keyword: string;
	active: boolean = true;

	@Input()
	objectiveid: number;


	constructor(router: Router,
		_route: ActivatedRoute,
		paramsService: ParamsService) {
		super(router, _route, paramsService);

	}

	ngOnInit() {
	}

	readQueryParams(params: string) {
		super.readQueryParams(params);
	}

	resetSearch() {
		this.keyword = undefined;
		this.active = true;
		super.resetSearch();
	}

	search(keeppage?: boolean) {
		this.setValues();
		super.search(keeppage);
	}

	setValues(): void { }



}
